import { PROJECT_NAME } from "../../utils/constants";

const Footer = () => {
  return (
    <footer className="bg-color1 text-black py-6 w-full mt-auto">
      <div className="container mx-auto text-center">
        <div className="md:flex justify-between">
          <div>
            <p>&copy;2025 <strong>{PROJECT_NAME}</strong> All Rights Reserved.</p>
          </div>
          <div className="mt-4 md:mt-0">
            <button className="text-black-400 hover:text-white px-4">
              Privacy Policy
            </button>
            <button className="text-black-400 hover:text-white px-4">
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;